import { Component, OnInit,OnDestroy } from '@angular/core';
import { addDays, distanceInWords } from 'date-fns';
import { ChatService } from 'src/app/services/chat.service';
import { Subscription } from 'rxjs';
/*para @ngrx/redux*/
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit,OnDestroy {
  elemento:HTMLElement;
  menssagesSubscription:Subscription=null;
  usuarioSubscription:Subscription=null;
  time = distanceInWords(new Date(), new Date());
  inputValue = '';
  submitting = false;
  user= {
    first_name:'',
    photo_url:'',
    role:''
  };
  data:any[] = [];
  constructor(private _chatService:ChatService,private store:Store<AppState>) { }

  ngOnInit() {
    //para el store
    this.usuarioSubscription=this.store.select('auth').subscribe((auth:any)=>{
      //ojo con esto de redux
     if(auth.user){
      console.log(auth.user)
      let{user:{first_name,photo_url,role}}=auth;
      this.user={first_name,photo_url,role}
     }
      
    });
    //para los mensajes
    this.menssagesSubscription=this._chatService.getMessages().subscribe((payload:any)=>{
      let {message:content,first_name:author,photo_url,role}=payload;
      console.log({content,author,photo_url,role});
      this.data.push({content,author,photo_url,role});
      console.log(this.data);
      this.elemento=document.getElementById('id-chat');
      setTimeout(()=>{
        this.elemento.scrollTop=this.elemento.scrollHeight;
      },500);
      
    });
  }

  ngOnDestroy(): void {
 
    this.menssagesSubscription.unsubscribe();
    this.usuarioSubscription.unsubscribe();
    
  }

  handleSubmit(): void {
    this.submitting = false;
    const message = this.inputValue.trim();
    let{first_name,photo_url,role}=this.user;
    this._chatService.sendMessage(message,first_name,photo_url,role);
    this.inputValue = '';
  }

}
